import { ROLE_ID } from '@/constants/roles';

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const formatIndianCurrency = (num) => {
  let [integerPart, decimalPart] = num.toString().split("."); // Split into integer and decimal parts
  let lastThree = integerPart.slice(-3);
  let rest = integerPart.slice(0, -3);

  if (rest !== "") {
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  }
  let formattedDecimal = decimalPart
    ? "." +
      parseFloat("0." + decimalPart)
        .toFixed(2)
        .split(".")[1]
    : "";
  return rest !== ""
    ? rest + "," + lastThree + formattedDecimal
    : lastThree + formattedDecimal;
};

export const formatToINR = (num) => {
  const integerPart = Math.floor(num); // or Math.trunc(num) if you don't want rounding
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0,
  }).format(integerPart);
}

export const isMobileView = () => {
  const userAgentCheck = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const screenSizeCheck = window.innerWidth <= 768;
  const touchCheck = "maxTouchPoints" in navigator && navigator.maxTouchPoints > 0;
  if (userAgentCheck || screenSizeCheck || touchCheck) {
      return true;
  }
  return false;
}
export const openDatePicker = (id) => {
  document.getElementById(id)?.click();
}

const SP_COMMUNICATION_NA = "NA";

/**
 * Fields for communication API payloads: SP email/mobile/name from session rm_data when RoleId is 2.
 */
export const getSpFieldsForCommunicationPayload = () => {
  const allNa = {
    spemail: SP_COMMUNICATION_NA,
    spmobile: SP_COMMUNICATION_NA,
    spname: SP_COMMUNICATION_NA,
  };
  try {
    const raw = sessionStorage.getItem("rm_data");
    if (!raw) {
      return allNa;
    }
    const rm = JSON.parse(raw);
    if (String(rm?.RoleId) !== ROLE_ID.RM) {
      return allNa;
    }
    const pick = (v) =>
      v != null && String(v).trim() !== "" ? String(v) : SP_COMMUNICATION_NA;
    return {
      spemail: pick(rm.Email),
      spmobile: pick(rm.Mobile),
      spname: pick(rm.Name),
    };
  } catch {
    return allNa;
  }
};